import React from "react";
import moment from "moment";
import { Box, Typography } from "@material-ui/core";
import { CustomCard } from "../../../../../Components";
import { formatNumberCompact } from "../../../../../Helper";

import useStyles from "./styles";

import { AEDIcon } from "../../../../../assets/icons";

function LastAcitivityCard({ transaction }) {
  const styles = useStyles();
  return (
    <CustomCard classes={styles.activityCard}>
      <Box className={styles.activityDetails}>
        <Typography variant="body2" component="p">
          {"Units transacted"}
        </Typography>
        <Typography variant="body2" component="p">
          {transaction?.transactionCount || 0}
        </Typography>
      </Box>
      <Box className={styles.activityDetails}>
        <Typography variant="body2" component="p">
          {"Lifetime value"}
        </Typography>
        <Typography variant="body2" component="p">
          {formatNumberCompact(transaction?.totalTransactionValue || 0)}
          <AEDIcon
            className={styles.aedIcon}
            width="30"
            height="30"
            aspect-ratio="1/1"
          />
        </Typography>
      </Box>
      <Box className={styles.activityDetails}>
        <Typography variant="body2" component="p">
          {"Last transaction"}
        </Typography>
        <Typography variant="body2" component="p">
          {transaction?.latestTransaction ? moment(transaction?.latestTransaction).format("DD, MMM YYYY") : "N/A"}
        </Typography>
      </Box>
    </CustomCard>
  );
}

export default LastAcitivityCard;
